import React, { Component } from "react";
 import {
  Route,
  HashRouter,
} from "react-router-dom";
import Home from "./Home";
import Archives from "./Archives";
import Technical from "./Technical";
import Techlinks from "./Techlinks";
import Logo from "./Logo";
import News from "./News";

// Import Picture files
/*import forums from './Forums.png';
import archives from './Archives.png';
import technical from './Technical.png';*/

import './main.css';


class Main extends Component {
  render() {
    return (
      <div>
      <Logo>
      </Logo>
      <footer>
      <HashRouter>
          <div className="content">
            <Route exact path="/" component={Home}/>
            <Route path="/archives" component={Archives}/>
            <Route path="/technical" component={Technical}/>  
            <Route path="/techlinks" component={Techlinks}/>  
            <Route path="/news" component={News}/>  

          </div>
      </HashRouter> 
      </footer>
      
      </div>
    );
  }
}
 
export default Main;


// WEBPACK FOOTER //
// ./src/Main.js